import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataEwallet(params) {
	return client.get("api/ecommerce/ewallet/data", {
		params: params,
	});
}

function exportEwallet(params) {
	return client.get("api/ecommerce/ewallet/export", {
		params: params,
	});
}

function getDataEwalletLog(params) {
	return client.get("api/ecommerce/ewallet/data-log", {
		params: params,
	});
}

function exportEwalletLog(params) {
	return client.get("api/ecommerce/ewallet/export-log", {
		params: params,
	});
}

function transferEwallet(params) {
	return client.post("api/ecommerce/ewallet/withdrawal_process", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getDataEwalletProcess(params) {
	return client.get("api/ecommerce/ewallet/data-process", {
		params: params,
	});
}

function exportEwalletProcess(params) {
	return client.get("api/ecommerce/ewallet/export-process", {
		params: params,
	});
}

function getDataEwalletWithdraw(params) {
	return client.get("api/ecommerce/ewallet/data-withdraw", {
		params: params,
	});
}

function exportEwalletWithdraw(params) {
	return client.get("api/ecommerce/ewallet/export-withdraw", {
		params: params,
	});
}

function getDataEwalletDetailWithdraw(params) {
	return client.get("api/ecommerce/ewallet/data-detail-withdraw", {
		params: params,
	});
}

function exportEwalletDetailWithdraw(params) {
	return client.get("api/ecommerce/ewallet/export-detail-withdraw", {
		params: params,
	});
}

export default {
	getDataEwallet,
	exportEwallet,
	getDataEwalletLog,
	exportEwalletLog,
	transferEwallet,
	getDataEwalletProcess,
	exportEwalletProcess,
	getDataEwalletWithdraw,
	exportEwalletWithdraw,
	getDataEwalletDetailWithdraw,
	exportEwalletDetailWithdraw,
}